<template>
  <div class="promo-bar" @click="$emit('open-form')">
    <div class="promo-link">
      <span class="promo-date">
        <span class="date-label">2026.04.22</span>
      </span>
      <span class="promo-divider"></span>
      <span class="promo-text">
        <strong class="highlight">청주시</strong>
        <strong class="amount">사업계획</strong>
        <strong class="approved">승인 완료</strong>
      </span>
      <span class="promo-arrow">›</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobilePromoBar',
  emits: ['open-form']
}
</script>

<style scoped>
.promo-bar {
  position: fixed;
  top: 60px; /* 모바일 헤더 높이 */
  left: 0;
  width: 100%;
  z-index: 999;
  background:
    linear-gradient(90deg, #0a0e1a 0%, #1a2238 50%, #0a0e1a 100%);
  cursor: pointer;
  overflow: hidden;
  border-bottom: 1px solid rgba(201, 169, 110, 0.4);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}

/* 상단 골드 라인 */
.promo-bar::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg,
    transparent 0%,
    rgba(201, 169, 110, 0.6) 20%,
    rgba(212, 175, 55, 1) 50%,
    rgba(201, 169, 110, 0.6) 80%,
    transparent 100%
  );
}

/* 골드 샤이머 */
.promo-bar::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 60%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(212, 175, 55, 0.18),
    transparent
  );
  animation: shimmer 3.5s ease-in-out infinite;
}

@keyframes shimmer {
  0% { left: -60%; }
  100% { left: 110%; }
}

.promo-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 14px 18px;
  color: #fff;
  text-decoration: none;
  position: relative;
  z-index: 2;
}

.promo-date {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.date-label {
  font-family: 'Georgia', 'Noto Serif KR', serif;
  font-size: 13px;
  font-weight: 600;
  color: #d4af37;
  letter-spacing: 1.2px;
  text-shadow: 0 0 8px rgba(212, 175, 55, 0.3);
  font-style: italic;
}

.promo-divider {
  width: 1px;
  height: 18px;
  background: linear-gradient(180deg,
    transparent 0%,
    rgba(212, 175, 55, 0.6) 50%,
    transparent 100%
  );
  flex-shrink: 0;
}

.promo-text {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.3px;
  display: flex;
  align-items: center;
  gap: 7px;
}

.promo-text .highlight {
  color: #fff;
  font-weight: 800;
  font-size: 18px;
  letter-spacing: 0;
}

.promo-text .amount {
  color: #d4af37;
  font-weight: 900;
  font-size: 19px;
  text-shadow: 0 0 12px rgba(212, 175, 55, 0.5);
  letter-spacing: -0.2px;
}

.promo-text .approved {
  color: #fff;
  font-weight: 800;
  font-size: 15px;
  padding: 2px 8px;
  border: 1px solid rgba(212, 175, 55, 0.6);
  border-radius: 2px;
  letter-spacing: 0.5px;
  background: rgba(212, 175, 55, 0.08);
  animation: glow 2.4s ease-in-out infinite;
}

@keyframes glow {
  0%, 100% {
    box-shadow: 0 0 0 rgba(212, 175, 55, 0);
    border-color: rgba(212, 175, 55, 0.6);
  }
  50% {
    box-shadow: 0 0 14px rgba(212, 175, 55, 0.5);
    border-color: rgba(212, 175, 55, 1);
  }
}

.promo-arrow {
  font-size: 22px;
  font-weight: 300;
  color: #d4af37;
  line-height: 1;
  animation: arrow-shift 1.8s ease-in-out infinite;
}

@keyframes arrow-shift {
  0%, 100% { transform: translateX(0); opacity: 0.7; }
  50% { transform: translateX(4px); opacity: 1; }
}

@media (max-width: 380px) {
  .promo-link {
    gap: 8px;
    padding: 13px 12px;
  }
  .promo-text {
    font-size: 14px;
    gap: 5px;
  }
  .promo-text .highlight {
    font-size: 15px;
  }
  .promo-text .amount {
    font-size: 16px;
  }
  .promo-text .approved {
    font-size: 13px;
  }
  .date-label {
    font-size: 11px;
    letter-spacing: 0.8px;
  }
  .promo-divider {
    height: 14px;
  }
}
</style>
